import { Button } from '../../../../Components/MUIs';
import { Box, Chip, Typography } from '@mui/material';
import checkImage from '../../../../Assets/Images/check.png';
import BackClickBottomSheetTbmEnd from '../../../../Components/Ui/BackClickBottomSheetTbmEnd';
import { useSelector, useDispatch } from 'react-redux';
import { createSignFileFromDataUrl } from '../../../../Components/Ui/SignBottomSheet';
import Canvas from '../../../../Components/Canvas/Canvas';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';

function M_FinalSign_BASIC(props) {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  const backSheet = bottomSheetState.type === 'backClickTbmEnd' && (
    <BackClickBottomSheetTbmEnd TbmEnd={props.TbmEnd} />
  );

  // 서명 후 캔버스 내용을 파일로 변환해 업로드 훅에 전달
  const handleCanvasEnd = () => {
    if (!props.signatureCanvas?.current) return;
    const dataURL = props.signatureCanvas.current.toDataURL('image/png');
    const file = createSignFileFromDataUrl(dataURL);
    props.setSignInputs({
      mapUrl: props.signatureCanvas.current.toDataURL(),
      mapFiles: file,
    });
    props.signUpload?.clearFiles?.();
    props.signUpload?.FileChange?.({ target: { files: [file] } });
  };

  const handleReset = () => {
    props.signatureCanvas?.current?.clear();
    props.signUpload?.clearFiles?.();
    props.setSignInputs({ mapUrl: '', mapFiles: {} });
  };

  const handleSave = () => {
    if (!props.signInputs.mapUrl) {
      dispatch(
        showSnackbar({ message: '서명을 완료해주세요.', type: 'warning' })
      );
      return;
    }
    props.SaveLogic1();
  };

  // 서명 전: 서명 페이지 (진행자·참석자 공통)
  if (!props.signed)
    return (
      <>
        <Box
          sx={{
            minHeight: '70vh',
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 2,
          }}
        >
          <Box
            sx={{
              p: 2,
              border: 1,
              borderColor: '#F3F4F6',
              borderRadius: 5,
              backgroundColor: '#fff',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 0.5,
              }}
            >
              <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                서명
              </Typography>
              <Chip
                sx={{ borderRadius: '8px' }}
                label="재설정"
                size="small"
                variant="outlined"
                onClick={handleReset}
              />
            </Box>
            <Typography sx={{ fontSize: '14px', color: '#828282', mb: 1.5 }}>
              TBM 내용을 확인했습니다. 아래에 서명해 주세요.
            </Typography>
            <Canvas
              signatureCanvas={props.signatureCanvas}
              userId={userInfo?.userNm}
              imageUrl={props.signInputs.mapUrl}
              disabled={false}
              onEnd={handleCanvasEnd}
            />
            <Typography
              sx={{
                mt: 1,
                fontSize: '13px',
                textAlign: 'center',
                color: 'text.secondary',
              }}
            >
              [필수] 서명 정보 수집 및 이용에 동의합니다.
            </Typography>
          </Box>
          <Button
            sx={{
              width: '100%',
              height: '36px',
              borderRadius: '18px',
              backgroundColor: '#2DB400',
              '&:hover': { backgroundColor: '#26a300' },
            }}
            name="서명 완료"
            onClick={handleSave}
          />
        </Box>
        {backSheet}
      </>
    );

  // 서명 후(참석자): TBM 완료 화면
  return (
    <>
      <Box
        sx={{
          minHeight: '70vh',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            alignSelf: 'flex-start',
            ml: 2.5,
            mb: '-38px', // 이미지 크기의 절반만큼 아래로 이동
          }}
        >
          <img src={checkImage} />
        </Box>
        <Box
          sx={{
            p: 2,
            px: 1,
            pt: 8,
            pb: 6,
            mb: 5,
            width: '100%',
            border: 1,
            borderColor: '#F3F4F6',
            borderRadius: 5,
            backgroundColor: '#fff',
            boxShadow: 0,
          }}
        >
          <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            금일 TBM 회의가 성공적으로 종료되었습니다.
          </Typography>
          <Typography
            sx={{ fontSize: '14px', color: '#828282', textAlign: 'center' }}
          >
            오늘도 안전을 위해 함께해주셔서 감사합니다.
          </Typography>
        </Box>
        <Button
          sx={{
            width: '100%',
            height: '36px',
            borderRadius: '18px',
          }}
          name="TBM 완료"
          onClick={props.GoHome}
        />
      </Box>
      {backSheet}
    </>
  );
}

export default M_FinalSign_BASIC;
